import * as _ from 'lodash'
import React, { useEffect } from 'react';
import componentServices from '../componentServices';
import * as actions from '../actions';
import * as vendorActions from '../vendorActions';import vendorFactory, { IVendor } from '../models/vendorModel';
import enums from '../enum';
import { useSaveRoot } from '../saveRoot';
import { IPatchOperation } from 'Scripts/modelFactory';
import { getModel, ModelCollection } from 'Scripts/store';

class VendorEditHeader extends React.Component<any,any> {
	handleRouteClick (key, e) {
		e.preventDefault();
		componentServices.router.pushHistory(componentServices.router.replacePathSegmentAt(3, key, true));
	}

	render () {
		const vendor = this.props.vendor;
		const items:JSX.Element[] = [];
		const isNewVendor = !vendor.relayId;

		const buttons = [{
			path: 'overview',
			name: 'Supplier Overview',
			featureSuffix: 'basic'
		}, {
			path: 'products',
			name: 'Products',
			featureSuffix: 'basic',
			hideForNew: true
		}, {
			path: 'factors',
			name: 'Cost Factors',
			featureSuffix: 'basic',
			includeType: enums.vendorTypes.Cabinet_Supplier,
			hideForNew: true
		}];

		_.forEach(buttons, x => {
			if (isNewVendor && x.hideForNew || (x.includeType && !(x.includeType & vendor.type))) {
				return;
			}

			let className = 'button';

			// TODO: deal with possible disabled status of header links
			className += (componentServices.router.getLastPathSegment() === x.path) ? ' on' : '';

			items.push(<li key={x.path}><a onClick={this.handleRouteClick.bind(this, x.path)} className={className}><span>{x.name}</span></a></li>);
		});

		//const className = 'jobStatus';
		const primaryContactName = (vendor && vendor.primaryContact) ? vendor.primaryContact.fullName : '';
		const primaryContactNumber = (vendor && vendor.primaryContact) ? vendor.primaryContact.mobilePhoneNumber || vendor.primaryContact.workPhoneNumber : '';

		return (
			<header key={ vendor.key }>
				<div className="builderStatus good">In Good Standing</div>
				<div className="clientInfo"><a href="">{primaryContactName}</a> <span>{primaryContactNumber}</span></div>
				<ul className="menu">
					{items}
				</ul>
			</header>
		);
	}
}

export default function VendorEdit(props) {
	const { routeParams } = componentServices;
	const vendorType = routeParams.vendortype;
	const vendorKey = routeParams.vendorkey;
	const saveRootConfig = {
		autoSave:  true,
		globalSave: true,
		warnOnLeave: true,
		stateId: `VendorEdit-${vendorKey}`,
		modelFactory: vendorFactory,
		resolveMutableModel (current: IVendor): [IVendor, boolean] {
			const { store } = componentServices;
			const storeVendor = getModel({ store, collection: ModelCollection.vendors, key: vendorKey })
			let vendor = current;
			let rebase = false;

			if (storeVendor) {
				if (!current || storeVendor.key !== current.key) {
					vendor = vendorFactory(storeVendor.toDocument());
				}
				else if (storeVendor.key === current.key && storeVendor.itemVersion !== current.itemVersion) {
					vendor = vendorFactory(storeVendor.toDocument());
					rebase = true;
				}
			}
			else if (!current) { // if we've reached this point, this is a new vendor
				const type = enums.vendorTypes[_.startCase(vendorType).replace(' ', '_')];
				vendor = vendorFactory({ key: vendorKey, type: type, status: 'active' });
			}

			return [vendor, rebase];
		},
		save: (doc, patch: IPatchOperation[]) => vendorActions.saveVendor({ vendor: doc, patch }),
		validate(model) {
			return model.test() || [];
		}
	}
	const [saveRoot] = useSaveRoot<IVendor>(saveRootConfig);
	const headerModel = saveRoot.model??saveRootConfig.resolveMutableModel(null)[0];

	useEffect(() => {
		actions.setHeader({
			key: 'vendorEditHeader',
			element: (<VendorEditHeader key={headerModel.key} vendor= { headerModel } />)
		});

		return () => {
			actions.deleteHeader({ key: 'vendorEditHeader' });
		}

	}, [headerModel])

	function updateModel (updater, options) {
		saveRoot.update((vendor) => {
			updater(vendor);

			if (vendor.primaryContact && vendor.primaryContact.isEmpty()) {
				vendor.primaryContact = undefined;
			}

			if (vendor.officeAddress && vendor.officeAddress.isEmpty()) {
				vendor.officeAddress = undefined;
			}
		}, options);
	}

	const { children, ...childProps } = props;
		
	return (saveRoot.model) ? children && React.cloneElement(children, _.assign({ vendor: saveRoot.model, updateModel: updateModel }, childProps)) : null;
}